export interface Config {
  env: string;
  version: string;
  amplify: amplify;
  omiseCraftCoreUrl: string;
  omiseCraftFilesUrl: string;
  omiseCraftStaticColumnsUrl: string;
  omiseCraftStaticContentsUrl: string;
  reCaptchaSiteKey: string;
  siteMode: string; // member / operator
  measurementId: string; // GA計測ID
  measurementAdId: string; // 広告用Google tag manager ID
  omiseCraftEmailAddress: string;
  cloudwatchRum: {
    applicationId: string;
    identityPoolId: string;
    region: string;
  };
}

export interface amplify {
  default: object;
  operator?: object;
}

export const loadConfig = async (): Promise<Config> => {
  const config = await import('./config.json');
  return { ...config.default, siteMode: import.meta.env.VITE_SITE_MODE ?? config.default.siteMode };
};
